import { createIcon } from './create-icon'

export const PauseO = createIcon({
  displayName: 'PauseO',
  paths: [
    'M512 128c-212.096 0-384 171.904-384 384s171.904 384 384 384c212.096 0 384-171.904 384-384s-171.904-384-384-384zM512 213.333c164.693 0 298.667 134.016 298.667 298.667s-133.973 298.667-298.667 298.667c-164.693 0-298.667-134.016-298.667-298.667s133.973-298.667 298.667-298.667zM597.333 341.333c-23.552 0-42.667 19.072-42.667 42.667v256c0 23.595 19.115 42.667 42.667 42.667s42.667-19.072 42.667-42.667v-256c0-23.595-19.115-42.667-42.667-42.667zM384 384c0-23.595 19.115-42.667 42.667-42.667s42.667 19.072 42.667 42.667v256c0 23.595-19.115 42.667-42.667 42.667s-42.667-19.072-42.667-42.667v-256z'
  ]
})
